<script setup lang="ts">
import type { Component } from 'vue'

/**
 * An icon-only control: `quiet` (default) for a row's own menu trigger, `bordered` for a
 * page-level one. The caller's `aria-label` falls through to the root element as usual.
 */
const props = withDefaults(defineProps<{ variant?: 'quiet' | 'bordered'; as?: string | Component }>(), {
  variant: 'quiet',
  as: 'button',
})

const VARIANT_CLASSES = {
  quiet:
    'text-[color:var(--color-text-muted)] transition-colors duration-[var(--motion-fast)] hover:bg-[color:var(--color-surface-sunken)] hover:text-[color:var(--color-text)]',
  bordered:
    'border border-[color:var(--color-border-control)] bg-[color:var(--color-surface)] text-[color:var(--color-text)]',
} as const
</script>

<template>
  <component
    :is="as"
    :type="as === 'button' ? 'button' : undefined"
    class="flex h-[var(--density-control)] w-[var(--density-control)] shrink-0 items-center justify-center rounded-[var(--radius-control)]"
    :class="VARIANT_CLASSES[props.variant]"
  >
    <slot />
  </component>
</template>
